import { List, Skeleton } from 'antd';
import { useGetDocuments } from 'api/documents/use-get-documents';
import { useStatePagination } from 'shared/hooks/use-state-pagination.ts';
import { DocumentItem } from 'components/documents/document-item';
import { Pagination } from 'components/pagination';
import type { IDocumentsListProps } from './types';
import { getDocumentSearchFields } from './utils';

export const DocumentsList = (props: IDocumentsListProps) => {
  const { limit, page, handlePageChange } = useStatePagination({ defaultLimit: 20 });

  const searchFields = getDocumentSearchFields(props);

  const { data: documents, isLoading } = useGetDocuments({ page, limit, ...searchFields });

  return (
    <Skeleton loading={isLoading}>
      <List
        size={'small'}
        itemLayout='horizontal'
        dataSource={documents?.data}
        renderItem={(document) => <DocumentItem key={document.id} document={document} />}
      />
      <Pagination total={documents?.pagination?.total} page={page} limit={limit} onChange={handlePageChange} />
    </Skeleton>
  );
};
